<template>
  <div class="main-container">
    <div class="title-back">
      <p class="title">详情</p>
      <Button type="primary" class="backBtn" @click="$router.back()">返回</Button>
    </div>
    <div class="status-salesman">
      <div class="status">
        <img v-if="policyDetail.payState == 2" src="@/assets/images/icon/org/fee-success.png" />
        <img v-else-if="policyDetail.payState == 3" src="@/assets/images/icon/org/fee-fail.png" />
        <img v-else src="@/assets/images/icon/org/fee-stay.png" />

        <span class="text success" v-if="policyDetail.payState == 2"
          >续费成功——{{ filters.filterTime(policyDetail.serverEndDate, 'YYYY-MM-DD') }}第{{ policyDetail.curRenewalTimes }}期保费已续费成功</span
        >
        <span class="text fail" v-else-if="policyDetail.payState == 3">续费失败——{{ policyDetail.payFailTypeDesc }}</span>
        <span class="text stay" v-else>待续费——{{ getDayText() }}</span>
        <!-- 待续费额外展示扣款失败原因 -->
        <span class="text fail" v-if="policyDetail.payState == 1 && policyDetail.payFailTypeDesc">扣款失败原因：{{ policyDetail.payFailTypeDesc }}</span>
      </div>
      <div class="salesman">
        业务员：
        <span class="user-info">{{ policyDetail.orgName }}</span>
        -
        <span class="user-info">{{ policyDetail.salesmanName }}</span>
      </div>
    </div>

    <form-item :formData="policyDetail" :status="status"></form-item>

    <Tabs v-model="tabIndex" @on-click="changeTab" :animated="false">
      <TabPane label="变更记录" name="1"></TabPane>
      <TabPane label="投保信息" name="2"></TabPane>
      <TabPane label="交费记录" name="3"></TabPane>
    </Tabs>

    <div class="stps" v-if="tabIndex == '1'">
      <div class="stps-item" v-for="(item, index) in changeRecordList" :key="index">
        <div class="outer-circle" v-if="index == 0">
          <div class="inner-circle"></div>
          <div class="line" v-if="changeRecordList.length !== index + 1"></div>
        </div>
        <div class="noactive-outer-circle" v-else>
          <div class="inner-circle"></div>
          <div class="line" v-if="changeRecordList.length !== index + 1"></div>
        </div>

        <div class="step-text">
          <span class="time" :style="{ color: index == 0 ? '#236dff' : '' }">{{ item.createDate }}</span>
          <span class="state" :style="{ color: index == 0 ? '#236dff' : '' }">{{ item.title }}</span>
          <span class="desc" v-html="item.content"></span>
          <span class="action-user">操作人：{{ item.userName }}</span>
          <Button
            type="primary"
            class="btn"
            icon="ios-create-outline"
            @click="$refs.followUp.open(row.commissionDTOList)"
            v-show="index == 0 && policyDetail.payState == 1"
          >
            跟进
          </Button>
        </div>
      </div>
    </div>

    <div v-if="tabIndex == '2'">
      <div class="info">
        <div class="title">基本信息</div>
        <div class="form">
          <div class="form-item">
            <span class="label">保障额度(元)</span>
            <span class="value">{{ insureInfoList.converage | filterNull }}</span>
          </div>

          <div class="form-item">
            <span class="label">保障期限</span>
            <span v-if="insureInfoList.guaranteeType == 1">保终身</span>
            <span v-if="insureInfoList.guaranteeType == 2">保{{ insureInfoList.guaranteeLimit }}岁</span>
            <span v-if="insureInfoList.guaranteeType == 3">保{{ insureInfoList.guaranteeLimit }}年</span>
            <span v-if="insureInfoList.guaranteeType == 4">保{{ insureInfoList.guaranteeLimit }}个月</span>
            <span v-if="insureInfoList.guaranteeType == 5">保{{ insureInfoList.guaranteeLimit }}天</span>
          </div>

          <div class="form-item">
            <span class="label">起保日期</span>
            <span class="value">{{ insureInfoList.effectTime | filterTime('YYYY-MM-DD') }}</span>
          </div>

          <div class="form-item no-mb">
            <span class="label">终保日期</span>
            <span class="value">{{ insureInfoList.endTime }}</span>
          </div>

          <div class="form-item no-mb">
            <span class="label">犹豫到期</span>
            <span class="value">{{ insureInfoList.hesitateTime | filterTime('YYYY-MM-DD') }}</span>
          </div>

          <div class="form-item no-mb">
            <span class="label">交费期限</span>
            <span class="value">{{ insureInfoList.paymentDesc | filterNull }}</span>
          </div>

          <div class="form-item no-mb">
            <span class="label">交费方式</span>
            <span class="value">{{ insureInfoList.payTypeDesc | filterNull }}</span>
          </div>
        </div>
      </div>

      <div class="info">
        <div class="title">投保人信息</div>
        <div class="form">
          <div class="form-item">
            <span class="label">姓名</span>
            <span class="value">{{ policyHoderForm.holderName }}</span>
          </div>

          <div class="form-item">
            <span class="label">性别</span>
            <span class="value">{{ policyHoderForm.holderSex | filterSex }}</span>
          </div>

          <div class="form-item">
            <span class="label">出生日期</span>
            <span class="value">{{ policyHoderForm.holderBirth | filterTime('YYYY-MM-DD') }}</span>
          </div>

          <div class="form-item">
            <span class="label">证件类型</span>
            <span class="value">{{ policyHoderForm.holderIdType | filterIdType }}</span>
          </div>

          <div class="form-item">
            <span class="label">证件号码</span>
            <span class="value">{{ policyHoderForm.holderIdNo | filterNull }}</span>
          </div>

          <div class="form-item">
            <span class="label">手机号码</span>
            <span class="value">{{ policyHoderForm.holderMobile | filterNull }}</span>
          </div>

          <div class="form-item">
            <span class="label">电子邮箱</span>
            <span class="value">{{ policyHoderForm.holderEmail | filterNull }}</span>
          </div>

          <div class="form-item">
            <span class="label">所在地区</span>
            <span class="value">{{ policyHoderForm.area }}</span>
          </div>

          <div class="form-item no-mb">
            <span class="label">详细地址</span>
            <span class="value">{{ policyHoderForm.holderAddress | filterNull }}</span>
          </div>
        </div>
      </div>

      <div class="info">
        <div class="title">被保险人信息</div>
        <div class="insured-form" v-for="(insureds, index) in insuredFormDynamic" :key="index">
          <div class="top" v-if="index + 1 < 3">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="form-left">
            <div class="form-item">
              <span class="label">姓名</span>
              <span class="value">{{ insureds.name | filterNull }}</span>
            </div>
            <div class="form-item">
              <span class="label">性别</span>
              <span class="value">{{ insureds.sex | filterSex }}</span>
            </div>
            <div class="form-item">
              <span class="label">出生日期</span>
              <span class="value">{{ insureds.birth | filterTime('YYYY-MM-DD') }}</span>
            </div>
            <div class="form-item">
              <span class="label">与投保人关系</span>
              <span class="value">{{ insureds.holderRelation | filterRelationShip }}</span>
            </div>
            <div class="form-item">
              <span class="label">证件类型</span>
              <span class="value">{{ insureds.idType | filterIdType }}</span>
            </div>
            <div class="form-item">
              <span class="label">证件号码</span>
              <span class="value">{{ insureds.idNo | filterNull }}</span>
            </div>
            <div class="form-item no-mb">
              <span class="label">手机号码</span>
              <span class="value">{{ insureds.mobile | filterNull }}</span>
            </div>
          </div>
          <div class="more-rights" @click="$refs.benefits.open(index)">
            <a>查看权益</a>
            <img src="@/assets/images/icon/org/right-icon.png" />
          </div>
        </div>
      </div>

      <div class="info">
        <div class="title">受益人信息</div>
        <div class="type">
          受益人类型
          <span class="type-text" v-if="beneficiaryType == 2">指定受益人</span>
          <span class="type-text" v-else-if="beneficiaryType == 1">法定受益人</span>
        </div>
        <Table v-if="row.sourceType != '1'" :columns="infoTableColumns" :data="benefitFormDynamic"></Table>
        <Table v-else :columns="infoTableColumns2" :data="benefitFormDynamic"></Table>
      </div>
    </div>

    <div class="pay-record" v-if="tabIndex == '3'">
      <div class="tabs" v-if="row.payType == 2">
        <div class="tab" @click="changeTabsYear(index)" v-for="(item, index) in tabsYear" :key="index" :class="{ 'active': index == tabsYearActiveIndex }">
          {{ item }}
        </div>
      </div>
      <Table :columns="payRecordColumns" :data="payRecordTableData"></Table>
    </div>

    <!-- 保障权益 -->
    <view-benefits ref="benefits" :policyNo="row.policyNo" :sourceType="row.sourceType"></view-benefits>

    <!-- 跟进 -->
    <follow-up-modal ref="followUp" :id="row.id" :isList="false" @updatePolicyData="updatePolicyData"></follow-up-modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import formItem from './components/formItem';
import { infoTableColumns, infoTableColumns2, payRecordColumns } from './form/detailColumns';
import filters from "@/api/filter";
import viewBenefits from './components/viewBenefits';
import followUpModal from './components/followUpModal';

export default {
  components: {
    formItem,
    viewBenefits,
    followUpModal
  },
  data() {
    return {
      timestamp: '',
      filters,
      row: {},
      policyDetail: {},
      status: '',//缴费状态
      tabIndex: '1',
      infoTableColumns,
      infoTableColumns2,
      tabsYearActiveIndex: 0,
      tabsYear: ['第一年', '第二年', '第三年', '第四年', '第五年'],
      payRecordColumns,
      payRecordTableData: [],
      changeRecordList: [],//变更记录
      insureInfoList: {},//基本信息
      policyHoderForm: {},//投保人信息
      insuredFormDynamic: [],//被保人
      benefitFormDynamic: [],//受益人信息
      beneficiaryType: [],//受益人类型
    }
  },

  filters: {
    filterNull(val) {
      if (!val) {
        return '-'
      }
      return val
    },
    filterStatus(val) {
      if (!val) {
        return '-'
      }
      if (val == '1') {
        return '已承保'
      } else if (val == '0') {
        return "已终止"
      } else if (val == '-1') {
        return '已退保'
      }
    },
    filterIdType(val) {
      if (!val) {
        return '-'
      }
      let value = val;
      if (val.length == 2) {
        value = val.charAt(val.length - 1);
      }
      switch (value) {
        case '1':
          return '身份证'
        case '2':
          return '护照'
        case '3':
          return '军人证'
        case '4':
          return '其他'
        case '5':
          return '户口本'
        case '6':
          return '出生证'
      }
    },
    filterSex(val) {
      if (!val) {
        return '-'
      }
      switch (val.toString()) {
        case '1':
          return '男'
        case '2':
          return '女'
      }
    },
  },

  created() {
    // 获取id
    this.row = JSON.parse(this.$route.query.row);
    this.status = this.$route.query.status;
    this.queryChangeRecord();
    this.queryInsurancePolicyData();
  },

  methods: {
    getDayText() {
      if (!this.timestamp || !this.policyDetail.lastPayDate) {
        return '';
      }
      const now = dayjs(new Date(this.timestamp)).format('YYYY-MM-DD') + ' 00:00:00';
      const lastPayDate = this.policyDetail.lastPayDate;
      if (now < lastPayDate) {
        const day = dayjs(lastPayDate).diff(now, 'day');
        return `距第${this.policyDetail.curRenewalTimes}期宽限期满日还剩${day}天`
      } else if (now == lastPayDate) {
        return `今天是第${this.policyDetail.curRenewalTimes}期宽限期满日`
      } else {
        const day = dayjs(now).diff(lastPayDate, 'day');
        return `第${this.policyDetail.curRenewalTimes}期宽限期满日已过${day}天`
      }
    },
    changeTab(value) {
      if (value == '1') {
        this.queryChangeRecord();
      } else if (value == '2') {
        this.queryInsuranceInfo();
      } else if (value == '3') {
        this.queryPayRecord();
      }
    },

    updatePolicyData() {
      this.queryChangeRecord();
      this.queryInsurancePolicyData();
    },

    // 保单详情
    queryInsurancePolicyData() {
      this.$http({
        url: `/buz/policyRenewalRecord/read/detail?id=${this.row.id}`,
        type: "GET",
      }).then((res) => {
        this.policyDetail = res.data;
        this.timestamp = res.timestamp;
      });
    },

    // 切换缴费记录年
    changeTabsYear(index) {
      this.tabsYearActiveIndex = index;
      this.queryPayRecord();
    },

    // 变更记录
    queryChangeRecord() {
      this.$http({
        url: `/buz/policyRenewalServiceLog/getByRecordId?recordId=${this.row.id}`,
        type: "GET",
      }).then((res) => {
        this.changeRecordList = res.data;
      });
    },

    // 投保信息
    // sourceType 1:线上 2:线下
    queryInsuranceInfo() {
      let url = this.row.sourceType == '1' ? `/buz/policy/read/detail?policyNo=${this.row.policyNo}` : `/buz/offlinePolicy/mechan/detailEnterPolicy?policyNo=${this.row.policyNo}`;
      this.$http({
        url,
        type: "GET",
      }).then((res) => {
        if (this.row.sourceType == '1') {
          //基础信息
          this.insureInfoList = {
            converage: res.data.converage, // 保额
            guaranteeLimit: res.data.guaranteeLimit, // 保障时间
            guaranteeType: res.data.guaranteeType, // 保障期限时间单位
            effectTime: res.data.startTime, // 起保日期
            hesitateTime: res.data.hesitateDate, // 犹豫到期
            endTime: res.data.endTime, // 终保日期
            payTypeDesc: res.data.payTypeDesc, // 交费方式
            paymentDesc: res.data.paymentDesc, // 交费期
          };

          // 投保人信息
          this.policyHoderForm = {
            holderName: res.data.holder.name,
            holderSex: res.data.holder.sex,
            holderBirth: res.data.holder.birthday,
            holderIdType: res.data.holder.cardType,
            holderIdNo: res.data.holder.cardNumber,
            holderMobile: res.data.holder.mobile,
            holderEmail: res.data.holder.email,
            area: res.data.holder.area,
            holderAddress: res.data.holder.address
          };

          // 被保险人
          this.insuredFormDynamic = res.data.insuresList.map(item => {
            return {
              name: item.name,
              sex: item.sex,
              birth: item.birthday,
              holderRelation: item.relationToHolder,
              idType: item.cardType,
              idNo: item.cardNumber,
              mobile: item.mobile
            }
          });
        } else {
          let productList = JSON.parse(JSON.stringify(res.data.productList))
          //基础信息
          this.insureInfoList = {
            converage: res.data.converage, // 保额
            effectTime: res.data.startTime, // 生效日期
            hesitateTime: res.data.hesitateTime, // 过犹豫期日期
            endTime: res.data.endTime, // 终止日期
            payTypeDesc: res.data.payTypeDesc, // 交费方式文本
            paymentDesc: res.data.paymentDesc, // 交费期限文本
            guaranteeLimit: productList[0].guaranteeLimit, // 保障期限
            guaranteeType: productList[0].guaranteeType, // 保障期限时间单位
          }

          //投保人
          this.policyHoderForm = res.data;
          this.policyHoderForm.term = res.data.holderValidPeriod == '终身' ? '' : res.data.holderValidPeriod // 有效期
          this.policyHoderForm.lifelong = res.data.holderValidPeriod == '终身' ? true : false // 终身

          // 被保险人
          this.insuredFormDynamic = res.data.insuranceList;
          this.insuredFormDynamic.map((item) => {
            if (item.validPeriod == '终身') {
              item.term = ''
              item.lifelong = true
            } else {
              item.term = item.validPeriod
              item.lifelong = false
            }
            // 权益信息处理
            if (item.rights) {
              item.rights1 = JSON.parse(item.rights)
            }
          })
        }
        // 受益人
        this.beneficiaryType = res.data.beneficiaryType;

        if (res.data.beneficiaryList && res.data.beneficiaryList.length > 0) {
          this.benefitFormDynamic = res.data.beneficiaryList
        }
      });
    },

    // 缴费记录
    queryPayRecord() {
      this.$http({
        url: "/buz/policyRenewalRecord/read/getRenewaled",
        type: "POST",
        data: {
          policyNo: this.row.policyNo,
          renewalYears: this.row.payType == 2 ? this.tabsYearActiveIndex + 1 : ''
        },
      }).then((res) => {
        this.payRecordTableData = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './detail.scss';
/deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
  font-weight: bold;
}
</style>